"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TotalConsumptionPrice = void 0;
const tslib_1 = require("tslib");
const apigw_models_1 = require("@integration/apigw-models");
const class_validator_1 = require("class-validator");
const decorators_1 = require("../../decorators");
class TotalConsumptionPrice extends apigw_models_1.Serializable {
}
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsNumber)(),
    (0, apigw_models_1.Docs)({ description: 'Consumption price', example: 1080.12 }),
    tslib_1.__metadata("design:type", Number)
], TotalConsumptionPrice.prototype, "amount", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsString)(),
    (0, apigw_models_1.Docs)({
        description: 'Description',
        example: 'Totaal elektriciteit Enkeltarief (1 t/m 10.000 kWh)',
    }),
    tslib_1.__metadata("design:type", String)
], TotalConsumptionPrice.prototype, "description", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    (0, apigw_models_1.Docs)({ description: 'Zone', example: '1' }),
    tslib_1.__metadata("design:type", String)
], TotalConsumptionPrice.prototype, "zone", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    (0, decorators_1.ExposeNameCase)(decorators_1.ExposeNameCaseEnum.SNAKE_CASE),
    (0, apigw_models_1.Docs)({ description: 'Unit of the consumption', example: '/kWh' }),
    tslib_1.__metadata("design:type", String)
], TotalConsumptionPrice.prototype, "unitOfMeasurement", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    (0, decorators_1.ExposeNameCase)(decorators_1.ExposeNameCaseEnum.SNAKE_CASE),
    (0, apigw_models_1.Docs)({ description: 'Unit of the price', example: '€' }),
    tslib_1.__metadata("design:type", String)
], TotalConsumptionPrice.prototype, "unitOfMeasurementAmount", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    (0, decorators_1.ExposeNameCase)(decorators_1.ExposeNameCaseEnum.SNAKE_CASE),
    (0, apigw_models_1.Docs)({
        description: 'Start date for the period of this price record (format dd-MM)',
        example: '21-04',
    }),
    tslib_1.__metadata("design:type", String)
], TotalConsumptionPrice.prototype, "fromDate", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    (0, decorators_1.ExposeNameCase)(decorators_1.ExposeNameCaseEnum.SNAKE_CASE),
    (0, apigw_models_1.Docs)({
        description: 'End date for the period of this price record (format dd-MM)',
        example: '20-04',
    }),
    tslib_1.__metadata("design:type", String)
], TotalConsumptionPrice.prototype, "toDate", void 0);
exports.TotalConsumptionPrice = TotalConsumptionPrice;
